import { useNavigationGuard } from "../context/NavigationGuardProvider ";

export const HandleUnsaveNavigationWithFun = () => {
  const { showDialog } = useNavigationGuard();

  return (e, showDialogFlag, onConfirm, onCancel) => {
    if (showDialogFlag) {
      e.preventDefault();
      showDialog(
        () => {
          if (onConfirm) onConfirm(); // run your custom function
        },
        () => {
          if (onCancel) onCancel(); // optional cancel handler
        }
      );
    } else {
      if (onConfirm) onConfirm(); // directly run if no dialog
    }
  };
};
